import MainTableApplication from '../../components/MainTableApplications/MainTableApplication'

const Applications = () => {

    return(
        <MainTableApplication type='leads' />
    )

}



export default Applications